import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table, Input, Alert } from 'reactstrap'
import { gql } from '@apollo/client'
import { enterKeyHandler } from '../../../utils'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import { handleGraphQLErrors } from '../../../utils'
import FormSubmitButton from '../FormSubmitButton'
import MonthSelectInput from '../../MonthSelectInput/MonthSelectInput'
import useForm from '../../CustomHooks/FormHook'
import { BILLED_HOURS_FORM_DATA_QUERY } from '../../../graphql.js'
import Spinner from '../../Spinner/Spinner'

const BILLED_HOURS_FORM_DATA = gql(BILLED_HOURS_FORM_DATA_QUERY)

export default function BilledHoursReportForm() {
  console.log('BilledHoursReportForm rendered')

  const inputStyle = {
    maxWidth: '125px',
    display: 'inline-block'
  }

  let init = {
    monthFrom: '1',
    monthTo: '12',
    yearFrom: '2017',
    yearTo: `${new Date().getFullYear()}`,
    timekeepers: [],
    reportType: 'S'
  }

  console.log('init: ', init)

  const navigate = useNavigate()
  init = initialFormValues('BilledHoursReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [showSpinner, setShowSpinner] = useState(false)
  const [formData, setFormData] = useState()
  console.log('inputs: ', inputs)

  useEffect(() => {
    async function fetchFormData() {
      try {
        setShowSpinner(true)
        const { data, errors } = await window.apolloClient.query({ query: BILLED_HOURS_FORM_DATA })
        if (data.billedHoursFormData) {
          console.log(data.billedHoursFormData)
          setFormData(data.billedHoursFormData)
        } 
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setShowSpinner(false)
      }
    }
    fetchFormData()
  }, [inputs])

  async function submitSearch() {
    console.log('BilledHoursReportForm.submitSearch', inputs)
    submitFormValues('BilledHoursReportForm', navigate, inputs, 'billedHours')
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger" style={{ marginTop: '50px'}}>{graphQLErrors[0].message}</Alert>
  }
  if (showSpinner) {
    return <Spinner />
  }

  if (formData) {

    const timeKeeperOptions = []
    for (let tk of formData.timekeepers) {
      timeKeeperOptions.push(<option key={tk.id} value={tk.id}>{tk.name}</option>)
    }
  
    const yearOptions = []
    for (let year = formData.yearMin; year <= formData.yearMax; year++) {
      yearOptions.push(<option key={year} value={year}>{year}</option>)
    }
    
    return (
      <div className="custom-scroll">
        <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '900px', margin: '20px auto' }}>
          <div>
            <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white', width: '500px' }}>
              <thead>
                <tr><th colSpan="2" className="custom-table-header">Billed Hours Report<span><br /></span></th></tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: 'middle' }}><b>Month</b></td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <b style={{ display: 'inline-block', paddingRight: '10px' }}>From</b><MonthSelectInput name={'monthFrom'} changeHandler={handleInputChange} defaultValue={inputs.monthFrom} style={inputStyle} />
                    <b style={{ display: 'inline-block', paddingRight: '10px', paddingLeft: '20px' }}>To</b><MonthSelectInput name={'monthTo'} changeHandler={handleInputChange} defaultValue={inputs.monthTo} style={inputStyle} />
                  </td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: 'middle' }}><b>Year</b></td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <b style={{ display: 'inline-block', paddingRight: '10px' }}>From</b>
                    <Input type="select" name="yearFrom" bsSize="sm" onChange={handleInputChange} defaultValue={inputs.yearFrom} style={inputStyle}>
                      {yearOptions}
                    </Input>
                    <b style={{ display: 'inline-block', paddingRight: '10px', paddingLeft: '20px' }}>To</b>
                    <Input type="select" name="yearTo" bsSize="sm" onChange={handleInputChange} defaultValue={inputs.yearTo} style={inputStyle}>
                      {yearOptions}
                    </Input>
                  </td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: 'middle' }}><b>Timekeeper</b></td>
                  <td>
                    <Input
                      type="select"
                      multiple
                      name="timekeepers"
                      onChange={handleInputChange}
                      bsSize="sm"
                    >
                      {timeKeeperOptions}
                    </Input>
                  </td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: 'middle' }}><b>Report Type</b></td>
                  <td>
                    <Input type="select" name="reportType" onChange={handleInputChange} bsSize="sm" defaultValue={inputs.reportType}>
                      <option value={'S'}>Summary</option>
                      <option value={'D'}>Detail</option>
                    </Input>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          <FormSubmitButton />
        </form>
      </div>
    )
  }
}
